"use client";

import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        <div className="h-4 w-24 bg-muted-dark-background animate-pulse rounded" />
        <div className="h-4 w-20 bg-muted-dark-background animate-pulse rounded" />
        <div className="h-4 w-20 bg-muted-dark-background animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-col gap-2">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="!text-[hsl(0,0%,100%)] hover:text-foreground transition-colors duration-[var(--duration-fast)] hover:underline underline-offset-4">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  return <footer className="w-full bg-dark-background text-foreground-dark py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {}
          <div className="flex flex-col gap-4">
            <img src="https://large-dingo.10web.cloud/wp-content/uploads/2026/01/ShowtimePNG-scaled.png" alt="Showtime Construction LLC" className="!w-[100px] !h-[100px]" />
            <p className="text-foreground-dark/90 text-sm">
              Your trusted home renovation & construction experts serving Jersey & PA.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-4 !text-[hsl(0,0%,100%)]">
            <h3 className="font-display text-lg font-semibold !text-[hsl(0,0%,100%)]">
              Quick Links
            </h3>
            <MenuProvider menu_id="4">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-display text-lg font-semibold !text-[hsl(0,0%,100%)]">
              Contact Us
            </h3>
            <div className="flex flex-col gap-2 text-foreground/80 text-sm">
              <Link to="tel:201-736-4633" className="transition-colors duration-[var(--duration-fast)] !text-[hsl(0,0%,100%)] hover:text-foreground">
                201-736-4633
              </Link>
              <Link to="tel:646-406-4601" className="transition-colors duration-[var(--duration-fast)] !text-[hsl(0,0%,100%)] hover:text-foreground">
                646-406-4601
              </Link>
              <Link to="mailto:info@showtimeconstructionllc.com" className="transition-colors duration-[var(--duration-fast)] !text-[hsl(0,0%,100%)] hover:text-foreground">
                info@showtimeconstructionllc.com
              </Link>
              <p className="!text-[hsl(0,0%,100%)]">Jersey & PA Area</p>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-display text-lg font-semibold !text-[hsl(0,0%,100%)]">
              Follow Us
            </h3>
            <div className="flex gap-4">
              <Link to="https://www.facebook.com/showtime.const/" className="text-foreground hover:text-primary transition-colors duration-[var(--duration-fast)]" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
              <Link to="https://www.instagram.com/showtimeconstruc/" className="text-foreground/80 hover:text-primary transition-colors duration-[var(--duration-fast)]" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
              <Link to="https://www.linkedin.com/feed/" className="text-foreground/80 hover:text-primary transition-colors duration-[var(--duration-fast)]" aria-label="LinkedIn">
                <Linkedin className="size-5" />
              </Link>
              <Link to="https://www.tiktok.com/@showtimeconstruction" className="text-foreground/80 hover:text-primary transition-colors duration-[var(--duration-fast)]" aria-label="TikTok">
                <svg className="size-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
              </Link>
              <Link to="https://x.com/home" className="text-foreground/80 hover:text-primary transition-colors duration-[var(--duration-fast)]" aria-label="X">
                <Twitter className="size-5" />
              </Link>
              <Link to="https://www.youtube.com/@hectorsavarin7618" className="text-foreground/80 hover:text-primary transition-colors duration-[var(--duration-fast)]" aria-label="YouTube">
                <svg className="size-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="mt-12 pt-8 border-t border-foreground/10 text-center text-foreground-dark/90 text-sm">
          <p>© {new Date().getFullYear()} Showtime Construction LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}